import { render, staticRenderFns } from "./property-address.vue?vue&type=template&id=108d212a"
import script from "./property-address.vue?vue&type=script&lang=js"
export * from "./property-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports